import { Container, Flex, IconButton, Image, Separator, Spacer, Stack, Link as LinkR } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { FaEnvelope } from "react-icons/fa"
import { FiSearch } from "react-icons/fi"
import { 
  // PiCalendarDots, 
  // PiHouse, 
  // PiUserFocus, 
  PiPhoneFill 
} from "react-icons/pi"
import Logo from "../../../public/assets/images/logo.svg"
// import HeaderButtons from "./header-buttons"
import { MobilePopover } from "./mobile-popover"
import { NavbarLinks } from "./navbar-links"
import { useSettings } from "./settings-context"

// const HEADER_BUTTONS = [
//   { href: "/events", icon: PiCalendarDots, name: "EVENTS" },
//   { href: "/jobs", icon: PiUserFocus, name: "JOBS" },
//   { href: "/immo", icon: PiHouse, name: "IMMO" },
// ]


const Header = () => {
  const policy = useSettings()?.policy
  const navigationPoints = useSettings()?.navigationPoints

  const logoSrc = policy?.logo
    ? policy.logo.path.replace(/-(LG)\./, "-MD.")
    : Logo

  const mobileIcons = [
    { icon: PiPhoneFill, label: "phone", link: "tel:+410344094001" },
    { icon: FaEnvelope, label: "mail", link: `mailto:${policy?.website_email ?? "info@wochen-zeitung.ch"}` },
  ]

  return (
    <Container
      as="header"
      maxW="full"
      p="0"
      mb="50"
      display="flex"
      flexDir={{ base: "column-reverse", md: "column" }}
      zIndex={100}
    >
      {/* Top Bar */}
      <Container
        py={{ base: "3.5", md: "4" }}
        bg="white"
        maxW="full"
        boxShadow={{ base: "lg", md: "none" }}
        pos="relative"
      >
        <Stack
          direction="row"
          gap={{ base: "4", md: "10" }}
          justify="center"
          h="full"
        >
          <Flex w="full" justifyContent="center">
            <Link to="/">
              <Image
                src={logoSrc}
                alt="Logo"
                width={{ base: "3xs", sm: "sm" }} />
            </Link>
          </Flex>

          {/* Desktop Header */}
          {/* <Flex
            pos="absolute"
            h="inherit"
            top={0}
            right={0}
            justifyContent="flex-end"
            alignItems="center"
            pr={8}
            hideBelow="md"
          >
            {HEADER_BUTTONS.map(btn => (
              <HeaderButtons key={btn.name} {...btn} />
            ))}
          </Flex> */}

          {/* Mobile nav */}
          <MobilePopover>
            <NavbarLinks hideFrom="md" navPoints={navigationPoints} />
          </MobilePopover>
        </Stack>
      </Container>

      {/* Bottom bar */}
      <Container py={{ base: "3.5", md: "4" }} bg="main" maxW="full" pos="relative">
        <Stack direction="row">
          {/* Mobile icons */}
          {mobileIcons.map(icon => (
            <LinkR href={icon.link} key={icon.label}>
              <IconButton
                variant="ghost"
                rounded="full"
                aria-label={icon.label}
                color="white"
                hideFrom="md"
              >
                <icon.icon size={25} />
              </IconButton>
            </LinkR>
          ))}

          <Spacer />

          {/* Desktop nav */}
          <Stack hideBelow="md" direction="row" gap={{ base: "4", md: "10" }}>
            <NavbarLinks navPoints={navigationPoints} />
          </Stack>

          <Spacer />

          {/* Search */}
          <Stack
            direction="row"
            gap={{ base: "2", md: "4" }}
            pos="absolute"
            right={5}
            top="50%"
            transform="translateY(-50%)"
          >
            <Separator
              orientation="vertical"
              borderWidth={1}
              borderColor="white"
              opacity="unset"
            />
            <Link to="/suche">
              <IconButton
                variant="ghost"
                rounded="full"
                aria-label="search"
                color="white"
                _hover={{ bg: "light", color: "main" }}
              >
                <FiSearch size={25} />
              </IconButton>
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Container>
  )
}

export default Header